var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTier2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.75 10a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0zm-2.625 0a6.125 6.125 0 1 1-12.25 0 6.125 6.125 0 0 1 12.25 0zm-5.772-3.146a.5.5 0 0 0-.707 0L6.853 9.646a.5.5 0 0 0 0 .708l2.793 2.793a.5.5 0 0 0 .707 0l2.793-2.793a.5.5 0 0 0 0-.708l-2.793-2.792z",
  clipRule: "evenodd"
})));
export default SvgTier2;